export default __webpack_public_path__ + "static/flo-5c3accf9e3c02f4c6dc6152aa7b701cb.jpg";